import {Box, Button, Flex, HStack, Text} from '@chakra-ui/react';
import React, {FC} from 'react';

import {clearCartWithProducts} from '../../../../api/requests';
import {useCartContext} from '../../../../components/providers';
import {TranslationKeys} from '../../../../translations';

interface CartHeaderProps {
  providerName: string;
  t: (term: TranslationKeys) => string;
  onOpenAlert: () => void;
  isEmptyCart?: boolean;
}

const CartHeader: FC<CartHeaderProps> = ({providerName, onOpenAlert, t, isEmptyCart}) => {
  const {cartItems} = useCartContext();

  const handleClearCart = async () => {
    try {
      const productIds = cartItems.map((item) => item.productId);

      await clearCartWithProducts({
        product_ids: productIds,
      });

      onOpenAlert();
    } catch (error) {
      console.error('Failed to clear cart:', error);
    }
  };

  return (
    <Box p="16px" borderBottom="1px solid" borderColor="gray.100">
      <HStack align="center" justify="space-between" _hover={{opacity: 0.8}}>
        <Flex align="center" justify="center">
          <Text fontSize="16px" fontWeight="600">
            {providerName}
          </Text>
          <Button variant="outline" minH="40px" ml="2" onClick={handleClearCart} disabled={isEmptyCart}>
            {t('CLEAR') + ' img'}
          </Button>
        </Flex>
        <Button variant="outline" minH="40px" mr="40px" onClick={onOpenAlert} disabled={isEmptyCart}>
          {t('CLEAR')}
        </Button>
      </HStack>
    </Box>
  );
};

export default CartHeader;
